<ng-container *ngIf="applicationEmails">
 <!-- Changed by amisha on 24/12/2025 -->
  @if (!templateForPermitForm) {
  <div
    class="row pl-3"
    *ngIf="activity.showResendEmails && canResendEmails() | async"
  >
    <button
      type="button"
      class="btn btn-raised btn-primary"
      (click)="resendEmail()"
      [disabled]="resendingEmail"
    >
      <span>{{ resendingEmail ? 'Sending...' : 'Resend Email' }}</span>
    </button>
    &nbsp;
    <app-loader *ngIf="resendingEmail"></app-loader>
  </div>
  <!-- Changed by amisha on 24/12/2025 -->
  } @else {
  <div
    class="permit-resend-wrapper"
    *ngIf="activity.showResendEmails && canResendEmails() | async"
  >
    <div class="resend-btn">
      <wm-common-button
        class="resend-btn"
        [data]="{
          text: resendingEmail ? 'Sending...' : 'Resend Email',
          disabled: resendingEmail,
          onClick: resendEmailClick
        }"
      >
      </wm-common-button>
    </div>

    <app-loader *ngIf="resendingEmail"></app-loader>
  </div>
  }
  <!-- End changed by amisha on 24/12/2025   -->

  <br />

  <div *ngFor="let applicationEmail of applicationEmails">
    <wm-log-email-view [logEmail]="applicationEmail"></wm-log-email-view>
  </div>
</ng-container>
<!-- // Added by amisha on 24/12/2025 -->
<wm-common-confirmation-modal
  [data]="confirmationModalData"
  (onOkClick)="handleModalOk()"
  (onCloseClick)="handleModalClose()"
>
</wm-common-confirmation-modal>
<!-- // End added by amisha on 24/12/2025 -->
